import styled from 'styled-components';
import IconButton from '../IconButton/IconButton';
const StyledButton = styled(IconButton) ``;
export default {
    Button: StyledButton,
};
